import React, { useState, useMemo, useEffect, useCallback } from 'react'
import TabStrip from '../../../organisms/Tabstrip';
import { _getComponent } from '../../../organisms/Tabstrip/getComponent';
import { Box } from '@mui/material';
import MyTask from './tabs/MyTask';
// import TeamTask from './tabs/TeamTask';
import Search from '../../../molecules/search';
import Filter from '../../../icons/Filter';
import CustomButton from '../../../atoms/CustomButton';
import CommonFilter from '../../../atoms/CommonFilter';
import { useParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { getData } from '../../../../services';
import TaskManagement from '../taskManagement';
import StatusBackground from '../../../atoms/StatusBackground';
import ColorDots from '../../../atoms/ColorDots';
import GraphContainer from '../home/GraphContainer';
import OverviewContainer from './tabs/Overview';
// import UserManagement from './UserManagement';
// import ClientManagement from './ClientManagement';
// import Departments from './Departments';
// import RoleManagement from './RoleManagement';


const EmployeeTaskManagement = () => {

  const [activeTab, setActiveTab] = useState("My Task");
  const { id } = useParams();
  const [cookies] = useCookies();
  const [information, setInformation] = useState();

  const onTabChange = (event, value) => {
    setActiveTab(value);
  };


  const data = useMemo(
    () => [
      {
        id: 1,
        label: "My Task",
        view: <TaskManagement information={information} type={"Project"} id={id} />,
      },
      {
        id: 2,
        label: "Overview",
        view: <OverviewContainer information={information} type={"Project"} id={id}/>,
      },
    ],
    [information]
  );

  const getProjectsData = useCallback(async () => {
    try {
      const res = await getData({
        endpoint: "Project/getProjectDetails",
        params: {
          project_id: id,
          // business_id: cookies.bid,
        },
        token: cookies.e_t,
      });
      if (res) {
        setInformation(res.data)
      }
    } catch (error) {
      console.error(error);
    }
  }, [cookies.e_t,]);

  useEffect(() => {
    getProjectsData();
  }, [getProjectsData]);




  return (
    <>
      <div className="main-container">
        <div className="d-flex gap-3 mb-0">
          <div className="ms-0 ql-container ql-snow border-0" >
            <div className='ql-editor p-0'>
              <div dangerouslySetInnerHTML={{ __html: information?.description }} />
            </div>
            {information?.priority || information?.status ? <div className='d-flex pt-2 gap-2'>
              <div
              ><ColorDots priority={information?.priority} background={true} /></div>
              <div
              ><StatusBackground status={information?.status} /></div>
            </div> : null}

          </div>
        </div>

      </div>

      <TabStrip activeTab={activeTab} onTabChange={onTabChange} data={data} />
      <Box sx={{ width: "100%" }}>
        <Box sx={{ p: '0px' }}>{_getComponent(data, activeTab)}</Box>
      </Box>

    </>
  )
}

export default EmployeeTaskManagement